export const defaultState = () => {
  return {
    apps: {
      loading: false,
      fetched: false,
      error: null,
      list: []
    },
    loading: false,
    fetched: false,
    appID: null,
    error: null
  };
};

const state = defaultState();

export default state;
